import { render, staticRenderFns } from "./UserPanel.vue?vue&type=template&id=45ea73d7&scoped=true"
import script from "./UserPanel.vue?vue&type=script&lang=js"
export * from "./UserPanel.vue?vue&type=script&lang=js"
import style0 from "./UserPanel.vue?vue&type=style&index=0&id=45ea73d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ea73d7",
  null
  
)

export default component.exports